import { useNavigate } from "react-router-dom";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from "../common/_customHooks/redux";
import { actions, selectors } from "./_redux";

export enum Access {
  PENDING = "pending",
  WRITE = "write",
  READ = "read",
}

/**
 * @Back-End response map:
 *
 * @response 0 (Read & Write Access)
 * @response 1 (Read Only Access)
 * @response Forbidden 403 (No Access) - User is redirected to the first possible menu item (redirectUrl)
 *
 * @return "pending" || "read" || "write"
 */
export const usePageAccessHook = (pageUrl: string): Access => {
  const dispatch = useDispatch();
  const { path, rights } = useSelector(selectors.userAccess);
  const redirectUrl = useSelector(selectors.getRedirectUrl);

  const navigate = useNavigate();

  const checkPageAccess = async () => {
    const access = await dispatch(actions.getUserAccess(pageUrl));
    
    if (access) {
      dispatch(
        actions.setUserAccess({
          path: pageUrl,
          rights: access,
        }),
      );
    } else {
      navigate(redirectUrl, { replace: true });
    }
  };

  if (path !== pageUrl) {
    if (pageUrl.includes(path)) return rights; // Prevent check for CRUD routes
    checkPageAccess();
    return Access.PENDING;
  } else {
    return rights;
  }
};
